import { render, staticRenderFns } from "./StudentRequirementSubmissionForm.vue?vue&type=template&id=54f3e4ae&scoped=true&"
import script from "./StudentRequirementSubmissionForm.vue?vue&type=script&lang=js&"
export * from "./StudentRequirementSubmissionForm.vue?vue&type=script&lang=js&"
import style0 from "./StudentRequirementSubmissionForm.vue?vue&type=style&index=0&id=54f3e4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3e4ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VDivider,VForm,VIcon,VRow,VSelect,VSubheader,VTextarea})
